import { ManagerOption, RuleFilterMetricMapping } from '../constants/createSegment';
import { epochToDateString } from './commonUtils';
import isEmpty from 'lodash/isEmpty';

export const parseRuleFilters = ruleDetails => {
  const metricName = RuleFilterMetricMapping[ruleDetails.metricName] ?? null;
  const lastHireDateInMillis = epochToDateString(ruleDetails.lastHireDateInMillis);
  const lastHireEndDateInMillis = epochToDateString(ruleDetails.lastHireEndDateInMillis);
  const isManager = ruleDetails.isManager ? ManagerOption.IS_MANAGER : ManagerOption.NOT_MANAGER;

  return {
    leaderJobLevel: ruleDetails.leaderJobLevel,
    employeeJobLevels: ruleDetails.targetEmployeeJobLevels,
    countries: ruleDetails.countries,
    leaderLogins: ruleDetails.leaderLogins,
    isManager,
    lastHireDateInMillis,
    dateOperator: ruleDetails.dateOperator,
    lastHireEndDateInMillis,
    metricValue: ruleDetails.metricValue,
    metricOperator: ruleDetails.metricOperator,
    metricName,
    metrics: parseMetricRules(ruleDetails?.metrics),
    isDirectReport: ruleDetails.isDirectReport,
  };
};

export const parseMetricRules = metrics => {
  if (isEmpty(metrics)) {
    return [];
  }
  metrics?.map(m => {
    m.metricName = RuleFilterMetricMapping[m.metricName];
    return m;
  });
  return metrics;
};
